export default [
    {
        name: 'administracao-papel',
        path: 'papel',
        redirect: 'papel/index',
        component: () => import(/* webpackChunkName: 'administracao-papel' */ '@/views/administracao/papel/Index'),
        children: [
            {
                meta: {title: 'Lista de papéis'},
                name: 'administracao-papel-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'administracao-papel' */ '@/views/administracao/papel/List'),
            },
            {
                meta: {title: 'Cadastro de papel'},
                name: 'administracao-papel-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'administracao-papel' */ '@/views/administracao/papel/Form'),
            },
            {
                meta: {title: 'Edição de papel'},
                name: 'administracao-papel-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'administracao-papel' */ '@/views/administracao/papel/Form'),
            },
        ],
    },
]